import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import {  SECONDORY_COLOR, formatCurrency, labelText } from "../common/sharedFunctions";
import moment from "moment";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';

export default function DriverEarning() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  
  const columns =  [
      { title: labelText(t, 'booking_ref', 'Booking Reference'), field: 'bookingReference'},
      { title: labelText(t, 'booking_date', 'Booking Date'), field: 'bookingDate', render: rowData => rowData.bookingDate ? moment(rowData.bookingDate).format('lll') : ""},
      { title: labelText(t, 'customer_name', 'Customer Name'), field: 'customerName'},
      { title: labelText(t, 'car_type', 'Vehicle Type'), field: 'vehicleType'},
      { title: labelText(t, 'driver_name', 'Driver Name'), field: 'driverName'},
      { title: t('vehicle_reg_no'), field: 'driverVehicleNo'},
      { title: labelText(t, 'accepted_bid_amount', 'Accepted Bid Amount'), field: 'grossAmount', render: rowData => formatCurrency(rowData.grossAmount || 0, settings)},
      { title: labelText(t, 'commission_type', 'Commission Type'), field: 'commissionType'},
      { title: labelText(t, 'garahex_commission', 'Garahex Commission'), field: 'garahexCommissionAmount', render: rowData => formatCurrency(rowData.garahexCommissionAmount || 0, settings)},
      { title: labelText(t, 'net_driver_earning', 'Net Driver Earning'), field: 'netAmount', render: rowData => formatCurrency(rowData.netAmount || rowData.driverShare || 0, settings)},
      { title: labelText(t, 'payment_mode', 'Payment Method'), field: 'paymentMode'},
      { title: labelText(t, 'booking_status_web', 'Booking Status'), field: 'bookingStatus'},
      { title: labelText(t, 'withdrawal_status', 'Withdrawal Status'), field: 'withdrawalStatus'},
      { title: labelText(t, 'source', 'Source'), field: 'source'}
  ];

  const [data, setData] = useState([]);
  const driverearningdata = useSelector(state => state.driverearningdata);

  useEffect(()=>{
        if(driverearningdata.driverearnings){
            setData(driverearningdata.driverearnings);
        }
  },[driverearningdata.driverearnings]);

  const [selectedRow, setSelectedRow] = useState(null);
  
  return (
    driverearningdata.loading? <CircularLoading/>:
      <ThemeProvider theme={theme}>
        <MaterialTable
          title={t('driver_earning_title')}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: "20px",
          }}
          data={data}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={{
            exportButton: true,
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
            }),
            ...TableStyle()
          }}
          localization={localization(t)}
        />
      </ThemeProvider>
  );
}
